import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { FavoriteButton } from 'shared/components/GalleryRedesigned/components/GallerySidebar';
import { trackFavoriteClick } from 'shared/containers/FavoriteButtonContainer/tracking';
import { getIsFavorite } from 'shared/selectors';
import { getOfferCustomUrl } from 'shared/selectors/analytics';
import { getRosreestrInfo } from 'shared/selectors/offerData/getRosreestrInfo';
import { changeFavoriteAction } from 'shared/store/offer';
import { IExtra, ISoprProducts } from 'shared/utils/tracking/types';

export const FavoriteButtonContainer: React.FC = () => {
  const checked = useSelector(getIsFavorite);
  const customUrl = useSelector(getOfferCustomUrl);
  const rosreestrInfo = useSelector(getRosreestrInfo);

  const dispatch = useDispatch();

  const handleChangeFavorite = React.useCallback(() => {
    const addAction = 'add_from_card_fullscreen_gallery';
    const removeAction = 'remove_from_card_fullscreen_gallery';
    const products = {
      extra: rosreestrInfo?.analyticsMeta
        ? ({
            rosreestrData: rosreestrInfo.analyticsMeta,
          } as IExtra)
        : undefined,
    } as ISoprProducts;

    trackFavoriteClick(checked ? removeAction : addAction, customUrl, products);

    dispatch(changeFavoriteAction());
  }, [rosreestrInfo, checked, customUrl, dispatch]);

  return <FavoriteButton checked={checked} onButtonClick={handleChangeFavorite} />;
};
